import type { Store } from '@libs/common-node';
import { CWEA_ENDPOINTS } from '../constants';
import { cweaClient } from '../clients/api-proxy-browser-client';

export type GetStoreByIdParams = {
    storeId: string;
};

// TODO: no need to pass an object
export async function getStoreById({ storeId }: { storeId: string }) {
    const url = CWEA_ENDPOINTS.stores.getStoreById(storeId);
    return await cweaClient.get<Store | null>(url);
}
